export default __webpack_public_path__ + "maps-examples-fill-pattern-thumbnail-960-c51d58b8f89a6ce6aa431fdc5f8170a8.webp";